import Icon from '@material-ui/icons/Event';

export const MatchIcon = Icon;

export { MatchEdit as default } from './MatchEdit';